import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
declare var $: any;
@Component({
  selector: 'app-rashifal-add',
  templateUrl: './rashifal-add.component.html',
  styleUrls: ['./rashifal-add.component.css']
})
export class RashifalAddComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) { }
  ngOnInit(): void {
    $('#datepicker').datepicker({
      format: "MM yyyy",
      minViewMode: 1,
      maxViewMode: 0,
      autoclose: true,
      orientation: "top",
      todayHighlight: true,
    }).on('hide', function (ev) {
      var today = ev.date;
      var mon = '';
      var month = (today.getMonth() + 1);
      var year = today.getFullYear();
      var day = 0;
      if (month == '1') { day = 31; mon = "01"; }
      if (month == '2') {
        mon = "02";
        if (year % 4 == 0) {
          day = 29;
        }
        else {
          day = 28;
        }
      }
      if (month == '3') { day = 31; mon = "03"; }
      if (month == '4') { day = 30; mon = "04"; }
      if (month == '5') { day = 31; mon = "05"; }
      if (month == '6') { day = 30; mon = "06"; }
      if (month == '7') { day = 31; mon = "07"; }
      if (month == '8') { day = 31; mon = "08"; }
      if (month == '9') { day = 30; mon = "09"; }
      if (month == '10') { day = 31; mon = "10"; }
      if (month == '11') { day = 30; mon = "11"; }
      if (month == '12') { day = 31; mon = "12"; }
      var date = '';
      var my = $('#datepicker').val();
      var year = my.substr(my.length - 4);
      var month = my.substr(0, my.length - 5);
      console.log(my);
      // if(Tithi_date < 10){
      //   var Tithi_date = 0+Tithi_date;
      // }
      date += '<div class="col-md-6 row"><label class="col-sm-4 col-form-label">મેષ(અ.લ.ઈ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_1" id="txtadvertise_text_below_1" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">વૃષભ(બ.વ.ઉ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_2" id="txtadvertise_text_below_2" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">મિથુન(ક.છ.ઘ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_3" id="txtadvertise_text_below_3" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">કર્ક(ડ.હ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_4" id="txtadvertise_text_below_4" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">સિંહ(મ.ટ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_5" id="txtadvertise_text_below_5" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">કન્યા(પ.ઠ.ણ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_6" id="txtadvertise_text_below_6" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">તુલા(ર.ત)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_7" id="txtadvertise_text_below_7" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">વૃશ્ચિક(ન.ય)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_8" id="txtadvertise_text_below_8" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">ધન(ભ.ધ.ફ.ઢ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_9" id="txtadvertise_text_below_9" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">મકર(ખ.જ.)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_10" id="txtadvertise_text_below_10" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">કુંભ(ગ.શ.સ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_11" id="txtadvertise_text_below_11" class="form-control" spellcheck="false"></textarea></div></div><div class="col-md-6 row"><label class="col-sm-4 col-form-label">મીન(દ.ચ.ઝ)</label> <div class="col-sm-8"><textarea name="txtadvertise_text_below_12" id="txtadvertise_text_below_12" class="form-control" spellcheck="false"></textarea></div></div>'
      $("#date1").html(date);
      // console.log(date)
      // console.log(day)
      // console.log(mon)
      // console.log(month)
    });
  }
  submit_form() {
    var routers = this.router;
    var th = this;
    $.validate({
      onSuccess: function () {
        th.DefaultComponent.loaderShow();
        $('.btn-success').attr('disabled', true);
        var form = $("#rashifal_form");
        var fd = new FormData(form[0]);
        var token = localStorage.getItem('login_token');
        $.ajax({
          url: environment.GeneralBaseUrl + 'save_rashifal',
          method: 'POST',
          data: fd,
          headers: {
            'Authorization': token
          },
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide();
            if (res.status) {
              th.toastr.success(res.message)
              routers.navigate(['/rashifal-list']);
            } else {
              if (res.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              }
              else {
                th.toastr.error(res.message)
              }
            }
            $('.btn-success').attr('disabled', false);
          }
        });
        return false;
      }
    });
  }
}
